import { decodeHTML, breakLine, clearHTML } from '@/utils/dom'

export default {
  install(Vue) {
    Vue.prototype.$domUtils = {
      decode: decodeHTML,
      nl2br: breakLine,
      clear: clearHTML,
    }
  }
}
